import * as React from 'react';
import { Featured } from '@zoopla-eng/zds/badges';
import FeaturedPropertyCard from './FeaturedPropertyCard';
import {
    internalPromos,
    internalPromoIds
} from './InternalPromoCard/internalPromoData';
import InternalPromoCard from './InternalPromoCard';
import {
    propertyWrapperStyle,
    styledFeaturePropertiesHeaderStyle
} from './FeaturedProperties.styles.css';

type InternalPromoId = typeof internalPromoIds[number];
type PromoIds = typeof internalPromoIds[number];

type Product =
    | {
          listingId: string;
          featuredType?: string | null;
          title?: string | null;
          price?: string | null;
          alternativeRentFrequencyLabel?: string | null;
          address?: string | null;
          branch?: {
              logoUrl?: string | null;
              name?: string | null;
          } | null;
          listingUris?: {
              detail?: string | null;
          } | null;
          features?:
              | ({
                    iconId?: string | null;
                    content?: number | null;
                } | null)[]
              | null;
          image?: {
              src?: string | null;
              responsiveImgList?:
                  | ({ src?: string | null; width?: number | null } | null)[]
                  | null;
          } | null;
      }
    | InternalPromoId;

export type FeaturedItem = (
    | { type: 'Internal Promo'; id: PromoIds }
    | { type: 'Featured Property'; data: Product }
) & { onClick: () => void };

export type Props = {
    featuredItems: FeaturedItem[];
    sectionType: 'sale' | 'rent';
    searchParam?: string;
    searchIdentifier: string;
} & React.HTMLProps<HTMLDivElement>;

function FeaturedProperties({
    featuredItems,
    sectionType,
    searchParam,
    searchIdentifier
}: Props) {
    const currentSection = sectionType === 'sale' ? 'for-sale' : 'to-rent';

    return featuredItems.length > 0 ? (
        <div className={propertyWrapperStyle} data-testid="featured-listings">
            <div
                className={styledFeaturePropertiesHeaderStyle}
                data-testid="featured-properties-badge"
            >
                <Featured />
            </div>
            {featuredItems.map((item) => {
                if (
                    item.type === 'Featured Property' &&
                    typeof item.data !== 'string'
                ) {
                    return (
                        <FeaturedPropertyCard
                            property={item.data}
                            key={item.data.listingId}
                            onClick={item.onClick}
                            searchIdentifier={searchIdentifier}
                        />
                    );
                }

                if (item.type === 'Internal Promo') {
                    return (
                        <InternalPromoCard
                            promo={internalPromos[item.id]}
                            key={item.id}
                            currentSection={currentSection}
                            searchParam={searchParam}
                            onClick={item.onClick}
                        />
                    );
                }

                return null;
            })}
        </div>
    ) : null;
}

export { internalPromoIds };
export default FeaturedProperties;
